/**
 * Browser-only stand-in for the Realtime Database, used by `npm start`.
 * Same JSON tree and path semantics (null deletes), persisted in localStorage.
 */
const KEY = 'money-db'
const listeners = new Set()

function load() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {} } catch { return {} }
}
let root = load()

function commit() {
  localStorage.setItem(KEY, JSON.stringify(root))
  const snapshot = structuredClone(root)
  listeners.forEach((cb) => cb(snapshot))
}

const parts = (path) => path.split('/').filter(Boolean)

function prune(obj) {
  for (const k of Object.keys(obj)) {
    const v = obj[k]
    if (v === null || v === undefined) delete obj[k]
    else if (typeof v === 'object' && !Array.isArray(v)) { prune(v); if (!Object.keys(v).length) delete obj[k] }
  }
  return obj
}

function write(path, value) {
  const p = parts(path)
  if (!p.length) { root = prune(structuredClone(value ?? {})); return }
  let node = root
  for (const k of p.slice(0, -1)) node = typeof node[k] === 'object' && node[k] !== null ? node[k] : (node[k] = {})
  const last = p.at(-1)
  if (value === null || value === undefined) delete node[last]
  else node[last] = typeof value === 'object' ? prune(structuredClone(value)) : value
  prune(root)
}

export function subscribe(cb) {
  listeners.add(cb)
  cb(structuredClone(root))
  return () => listeners.delete(cb)
}
export async function setAt(path, value) { write(path, value); commit() }
export async function updateAt(path, patch) {
  for (const [k, v] of Object.entries(patch)) write(`${path}/${k}`, v)
  commit()
}
export async function removeAt(path) { write(path, null); commit() }
export async function add(path, value) {
  const id = Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
  write(`${path}/${id}`, value)
  commit()
  return id
}
export async function replaceAll(value) { write('', value); commit() }

// Keep several open tabs in sync.
window.addEventListener('storage', (e) => { if (e.key === KEY) { root = load(); listeners.forEach((cb) => cb(structuredClone(root))) } })
